import React, { useEffect, useState } from "react";

import DialerCampaignSkipTracePanel from "assets/images/campaigns/dialer-campaign-skip-trace-panel.svg";
import PersonSearchWhite from "assets/images/person-search-white.svg";
import SkipTraceHandler from 'app/components/SkipTraceHandler';
import css from "./style.scss";

const SkipTraceButton = ({ contactIds }) => {

  const [skipTraceContactIds, setSkipTraceContactIds] = useState(null);
  const [startSkipTrace, setStartSkipTrace] = useState(false);

  const handleSkipTraceProcessed = () => {
    // Reset state after handler processes the request
    setStartSkipTrace(false);
  };

  return (
    <>
      <div className={css.skipTraceBtnWrapper} onClick={() => {
        setSkipTraceContactIds(contactIds);
        setStartSkipTrace(true);
      }}>
        <button className={css.skipTraceBtn}>
          <img src={PersonSearchWhite} alt="PersonSearch" />
          <span className={css.skipTraceBtnTxt}>Skip Trace</span>
        </button>
      </div>

      <SkipTraceHandler 
        contactIds={skipTraceContactIds} 
        startSkipTrace={startSkipTrace}
        onProcessed={handleSkipTraceProcessed}
      />
    </>
  );
};

export default SkipTraceButton;
